import { openDB } from 'idb';
import { setItem } from './localStorage';

const MIGRATION_FLAG = '__migrated__';

export async function migrateFromLocalforageIfNeeded(): Promise<void> {
  try {
    const lfDb = await openDB('localforage', 99);
    if (!lfDb.objectStoreNames.contains('keyvaluepairs')) {
      return;
    }

    const flagTx = lfDb.transaction('keyvaluepairs', 'readonly');
    const alreadyMigrated = await flagTx.objectStore('keyvaluepairs').get(MIGRATION_FLAG);
    if (alreadyMigrated) {
      return;
    }

    const tx = lfDb.transaction('keyvaluepairs', 'readonly');
    const store = tx.objectStore('keyvaluepairs');
    const allKeys = await store.getAllKeys();

    await Promise.all(
      allKeys
        .filter((key) => key !== MIGRATION_FLAG)
        .map(async (key) => {
          const value = await store.get(key);
          await setItem(key as string, value);
        })
    );

    const writeTx = lfDb.transaction('keyvaluepairs', 'readwrite');
    await writeTx.objectStore('keyvaluepairs').put(true, MIGRATION_FLAG);

    lfDb.close();

    await new Promise<void>((resolve, reject) => {
      const request = indexedDB.deleteDatabase('localforage');
      request.onsuccess = () => resolve();
      request.onerror = () => reject(request.error);
      request.onblocked = () => resolve(); // Gracefully continue even if blocked
    });
  } catch {
    // Swallow errors silently as requested
  }
}
